export default __webpack_public_path__ + "static/media/fragment.6babb1e7.svg";